const testimonials = [
  {
    name: "Dmitri K.",
    location: "Sunny Isles Beach, FL — Trump International",
    rating: 5,
    text: "I am a Russian-American businessman with an office on Collins Avenue. My mother in Moscow had a heart attack and I needed to be there within 72 hours. I pulled my passport and realized it had expired two months ago. I called Fast Passport Center in complete panic. They understood the urgency immediately — no one asked me to repeat the story three times. They walked me through the exact documents I needed, I shipped everything overnight from the UPS Store on Collins Avenue, and I had my new passport in 3 days. I made it to Moscow in time to be with my mother. I have recommended them to every Russian friend I have in Sunny Isles.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "The Cohen Family",
    location: "Sunny Isles Beach, FL — Acqualina Resort area",
    rating: 5,
    text: "Our daughter's bat mitzvah group trip to Israel was planned for December 15th — flights from MIA on El Al, 18 family members traveling together. In late November, we discovered that our daughter's passport had expired when she turned 16 and her child passport was no longer valid. We needed an adult passport for her in less than three weeks. Fast Passport Center processed her application in 4 business days. The team was incredibly patient with the parental consent and documentation requirements, and they made sure everything was correct before submission. All 18 of us made it to Israel. I tell every family at our synagogue about them.",
    service: "Child-to-Adult Passport Renewal",
  },
  {
    name: "Maria Elena R.",
    location: "Sunny Isles Beach, FL — Newport Beachside area",
    rating: 5,
    text: "I am a Colombian entrepreneur with offices in Sunny Isles Beach and Bogota. I had a critical investor meeting in Medellin scheduled for a Monday. On Wednesday afternoon I realized my passport had water damage from a day at Sunny Isles Beach Pier and was no longer valid. I thought I would have to cancel the meeting and potentially lose a major investment. Fast Passport Center processed a damaged passport replacement in 72 hours. I shipped Thursday morning from the FedEx on Collins Avenue, had my new passport by Saturday, and made my Monday meeting in Medellin. Their team understood the business urgency and treated it like the priority it was.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SunnyIslesTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Sunny Isles Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Sunny Isles Beach residents who trusted Fast Passport Center with their expedited passports — from Trump International to Acqualina to Newport Beachside.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}